import App from '../app';
import soundbites from './soundbites';

const Modules = {
    soundbites
}

App.init(Modules);
